import React from "react";
import styled from "styled-components";

import { Strings } from "--root/strings/en";

import { ChooseDialogBody, ChooseDialogHeader } from "./components/ChooseDialog";
import ChooseSpaceForm, { ChooseSpaceFormProps } from "./components/ChooseSpaceForm";

const StyledChooseSpaceDialog = styled.form`
    display: contents;
`;

export interface ChooseSpaceDialogProps extends ChooseSpaceFormProps {
    title?: string;
}

const ChooseSpaceDialog = (props: ChooseSpaceDialogProps) => {
    const {
        title = Strings.chooseSpaceDialog.defaultTitle,
        ...formProps
    } = props;

    return (
        <StyledChooseSpaceDialog>
            <ChooseDialogHeader title={title} onClose={props.onClose} />
            <ChooseDialogBody>
                <ChooseSpaceForm {...formProps} />
            </ChooseDialogBody>
        </StyledChooseSpaceDialog>
    );
};

export default ChooseSpaceDialog;
